import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Users, KeyRound, Layers, Package } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useRefs } from "@/lib/useRefs";
import { PageHeader } from "@/components/Common";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAccess from "@/pages/admin/AdminAccess";
import AdminRoles from "@/pages/admin/AdminRoles";
import AdminPrograms from "@/pages/admin/AdminPrograms";

const TABS = [
  { id: "users", label: "Users", icon: Users },
  { id: "access", label: "Access", icon: KeyRound },
  { id: "roles", label: "Roles & Levels", icon: Layers },
  { id: "programs", label: "Programs", icon: Package },
];

export default function Admin() {
  const { user } = useAuth();
  const refs = useRefs();
  const [tab, setTab] = useState("users");

  if (!user?.is_admin) return <Navigate to="/manage/overview" replace />;

  return (
    <div>
      <PageHeader
        eyebrow="Console · Administration"
        title="Administration"
        subtitle="Identity and structure: who exists, what they can reach, and which programs exist."
        testid="admin-header" />

      <div className="flex gap-1 overflow-x-auto kp-scroll pb-2 mb-8 border-b border-border">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`admin-tab-${t.id}`}
            className={`flex items-center gap-2 text-sm font-medium px-4 py-2.5 rounded-t-lg whitespace-nowrap border-b-2 -mb-[2px] transition-all ${
              tab === t.id
                ? "border-primary text-primary bg-secondary/30"
                : "border-transparent text-muted-foreground hover:text-foreground hover:bg-secondary/20"}`}>
            <t.icon className="w-4 h-4" /> {t.label}
          </button>
        ))}
      </div>

      <div className="kp-in">
        {tab === "users" && <AdminUsers refs={refs} />}
        {tab === "access" && <AdminAccess refs={refs} />}
        {tab === "roles" && <AdminRoles refs={refs} />}
        {tab === "programs" && <AdminPrograms refs={refs} />}
      </div>
    </div>
  );
}
